import React from 'react';
import classNames from 'classnames';
import {string} from 'prop-types';
import {T} from 'ramda';

export const Action = ({className, id, icon, info, label, siteSlug, target, uuid}) => (
  <div id={id}
    className={classNames('sda-setting-link', className)}
    data-icon={icon}
    data-title={label}
    data-url={`${target}/${siteSlug}/${uuid}`}
    data-info={info} />
);

Action.displayName = 'Action';
Action.propTypes = {
  className: string,
  id: string,
  icon: string,
  info: string,
  label: string,
  siteSlug: string,
  target: string,
  uuid: string,
};

export default Action;


// buildAction :: ({id, label, info, target, icon, props, checkVisible}) -> {id, render}
//   checkVisible :: userModel -> Boolean
//   render :: userModel -> React.PropTypes.node
export const buildAction = ({className, id, label, target, icon, checkVisible = T, ...props}) => {
  const render = appContext => checkVisible(appContext)
    ? (
      <Action key={id} {...{className, id, icon, label, target}} {...props} />
    )
    : null;

  return {
    id,
    render,
  };
};
